import { languageHelper } from "../../../../config/helperFunctions";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { apiKey } from "../../../../config/config";
import { useReactToPrint } from "react-to-print";

function SummaryReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState();
  const today = new Date().toISOString().slice(0, 10);
  const [from, setFrom] = useState(today);
  const [to, setTo] = useState(today);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Summary_Report_${from}_to_${to}`,
    removeAfterPrint: true,
    // black and white print
    pageStyle: `
      @media print {
        * {
          color: #000 !important;
          background: #fff !important;
          box-shadow: none !important;
          text-shadow: none !important;
        }

        body {
          -webkit-print-color-adjust: economy;
          color-adjust: economy;
        }
      }
    `,
  });

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/summary-report`, {
        params: {
          outletId: user?.user.outlet_id,
          from: from,
          to: to,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [from, to, user?.user.outlet_id]);
  return (
    <main>
      <div className="text-d-bg-text text-3xl text-center my-8">
        {languageHelper("Summary Report")}
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <div className="md:flex block flex-wrap  gap-5 ms-4 my-2 items-center ">
        <div>
          <label htmlFor="" className="w-full lg:w-1/3">
            <span className="text-d-bg-text text-sm mb ">{languageHelper("Start Date")}</span>
            <div className="mb-2 pt-0">
              <input
                type="date"
                className="px-2 py-2  text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                required
                value={from}
                max={to}
                onChange={(e) => setFrom(e.target.value)}
              />
            </div>
          </label>
        </div>
        <div>
          <label htmlFor="" className="w-full lg:w-1/3">
            <span className="text-d-bg-text text-sm mb ">{languageHelper("End Date")}</span>
            <div className="mb-2 pt-0">
              <input
                type="date"
                className="px-2 py-2  text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                required
                value={to}
                min={from}
                onChange={(e) => setTo(e.target.value)}
              />
            </div>
          </label>
        </div>
        <button
          className="bg-d-cat-btn text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150 mt-3 w-fit ms-auto"
          type="button"
          onClick={handlePrint}
        >
          {languageHelper("Print")}
        </button>
      </div>
      <div>
        <h1 className="text-d-bg-text text-3xl text-center ">Imdady RMS</h1>
      </div>
      <div ref={componentRef}>
        <div className="my-12">
          <div className="my-10">
            <h1 className="text-d-bg-text text-2xl text-center ">
              {languageHelper("Summary Report")}
            </h1>
            <p className="text-d-bg-text text-center">
              {languageHelper("Date")}: {from === to ? from : `${from} — ${to}`}
            </p>
          </div>
          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3 border-r-2 border-black">{languageHelper("SN")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Reference No")} </th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Supplier")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("G. Total")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Paid")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Due")}</th>
              </tr>
            </thead>
            <tbody>
              {data?.supplier_report?.map((item, i) => (
                <tr key={i}>
                  <td className="py-1 px-2 border-r-2 border-black">{i + 1}</td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item.reference_no}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item.supplier.name}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item.grand_total}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">{item.paid}</td>
                  <td className="py-1 px-2 border-r-2 border-black">{item.due}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black">{languageHelper("Sum")}</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {data?.supplier_report?.reduce(
                    (acc, item) => acc + Number(item.grand_total),
                    0
                  )}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {data?.supplier_report?.reduce(
                    (acc, item) => acc + Number(item.paid),
                    0
                  )}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {data?.supplier_report?.reduce(
                    (acc, item) => acc + Number(item.due),
                    0
                  )}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            {languageHelper("Sale")}
          </h1>
          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">{languageHelper("SN")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Reference No")} </th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Order Type")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Table")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Customer")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Total Payable")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Discount")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Paid")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Due")}</th>
              </tr>
            </thead>
            <tbody>
              {data?.orders_report?.map((item, i) => (
                <tr>
                  <td className="py-1 px-2 border-r-2 border-black">{i + 1}</td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.sale_no}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.order_type?.name}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.table?.name}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item.customer_id !== 0
                      ? item?.customer?.name
                      : item?.guest?.name}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.total_payable}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.total_discount_amount}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.paid_amount}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.due_amount}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black">{languageHelper("Sum")}</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.orders_report?.reduce(
                      (acc, item) => acc + Number(item.total_payable),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.orders_report?.reduce(
                      (acc, item) => acc + Number(item.total_discount_amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.orders_report?.reduce(
                      (acc, item) => acc + Number(item.paid_amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.orders_report?.reduce(
                      (acc, item) => acc + Number(item.due_amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            {languageHelper("Expenses")}
          </h1>
          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">{languageHelper("SN")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Amount")} </th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Category")}</th>
                <th className="py-3 border-r-2 border-black">
                  {languageHelper("Responsible Person")}
                </th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Note")}</th>
              </tr>
            </thead>
            <tbody>
              {data?.expense_report?.map((item, index) => (
                <tr key={index} className="text-center border-t-2 border-black">
                  <td className="py-1 px-2border-r-2 border-black">{index + 1}</td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item.amount}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.category?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.user?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.note}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black">{languageHelper("Sum")}</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.expense_report?.reduce(
                      (acc, item) => acc + Number(item.amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            {languageHelper("Supplier Due Payments")}
          </h1>
          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">{languageHelper("SN")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Amount")} </th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Supplier")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Note")}</th>
              </tr>
            </thead>
            <tbody>
              {data?.supplier_due_report?.map((item, index) => (
                <tr key={index} className="text-center border-t-2 border-black">
                  <td className="py-1 px-2border-r-2 border-black">{index + 1}</td>
                  <td className="py-1 px-2border-r-2 border-black">{item.due}</td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.supplier?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.note}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black">{languageHelper("Sum")}</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.supplier_due_report?.reduce(
                      (acc, item) => acc + Number(item.due),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            {languageHelper("Expense Supplier Due")}
          </h1>
          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">{languageHelper("SN")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Invoice Reference")} </th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Supplier")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Total Amount")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Paid")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Due")}</th>
              </tr>
            </thead>
            <tbody>
              {data?.expense_supplier_due_report?.map((item, index) => (
                <tr key={index} className="text-center border-t-2 border-black">
                  <td className="py-1 px-2border-r-2 border-black">{index + 1}</td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.invoice_reference}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.supplier?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.total_amount}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.paid}</td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.due}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black">{languageHelper("Sum")}</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.expense_supplier_due_report?.reduce(
                      (acc, item) => acc + Number(item.total_amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.expense_supplier_due_report?.reduce(
                      (acc, item) => acc + Number(item.paid),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.expense_supplier_due_report?.reduce(
                      (acc, item) => acc + Number(item.due),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            {languageHelper("Customer Due Receives")}
          </h1>

          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">{languageHelper("SN")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Amount")} </th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Customer")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Note")}</th>
              </tr>
            </thead>
            <tbody>
              {data?.customer_due_report?.map((item, index) => (
                <tr key={index} className="text-center border-t-2 border-black">
                  <td className="py-1 px-2border-r-2 border-black">{index + 1}</td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item.due_amount}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.customer?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.order_note}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center">
                <td className="py-1 px-2 border-r-2 border-black">{languageHelper("Sum")}</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.customer_due_report?.reduce(
                      (acc, item) => acc + Number(item.due_amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            {languageHelper("Waste")}
          </h1>

          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">{languageHelper("SN")}</th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Reference No")} </th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Loss Amount")}</th>
                <th className="py-3 border-r-2 border-black">
                  {languageHelper("Responsible Person")}
                </th>
                <th className="py-3 border-r-2 border-black">{languageHelper("Note")}</th>
              </tr>
            </thead>
            <tbody>
              {data?.waste_report?.map((item, index) => (
                <tr key={index} className="text-center border-t-2 border-black">
                  <td className="py-1 px-2border-r-2 border-black">{index + 1}</td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.reference_no}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.total_loss}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.responsible_person?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.note}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black">{languageHelper("Sum")}</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.waste_report?.reduce(
                      (acc, item) => acc + Number(item.total_loss),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </main>
  );
}

export default SummaryReport;
